import { FC } from 'react'
import type { IconProps } from '../types'

// prettier-ignore
const CloseIcon: FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M4 20L12 12M12 12L20 4M12 12L20 20M12 12L4 4' stroke={color} strokeWidth='2' strokeLinecap='round' />
  </svg>
)

export default CloseIcon
